import React from "react";
import { Link } from "react-router-dom";

function Kpi({ label, value, action = null }) {
  return (
    <div className="min-w-0">
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <div className="font-mono text-[10px] uppercase tracking-[0.1em] text-theme-dim">{label}</div>
        {action}
      </div>
      <div className="mt-1 text-2xl md:text-3xl lg:text-4xl font-bold text-theme-on-background tabular-nums leading-tight">
        {value}
      </div>
    </div>
  );
}

export default function AuditDashboardKpis({ kpis }) {
  const k = kpis || {};

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-x-6 gap-y-6 md:gap-x-10 md:gap-y-5 w-full py-2 border-b border-theme-border">
      <Kpi label="Processed emails" value={k.examined_inbounds ?? 0} />
      <Kpi label="Cold inbound" value={k.cold_pitch_inbounds ?? 0} />
      <Kpi label="Lead emails" value={k.lead_emails ?? 0} />
      <Kpi label="ICP Matches" value={k.total_leads ?? 0} />
      <Kpi
        label="Brands"
        value={k.brand_count ?? 0}
        action={
          <Link to="/settings/brand/new/" className="font-mono text-[10px] uppercase tracking-wide text-theme-primary hover:opacity-80">
            Add New
          </Link>
        }
      />
    </div>
  );
}
